<template>
<section class="w1312 main-content-wrap">
  <div class="course-container clearfix">
    <div class="lefter-container">
      <div  class="lefter-title">
        课程分类 | {{sessionTarget === 1 ? 'MP商家' : '自营商家'}}
      </div>

      <ul class="clearfix">
        <li v-for="(item, index) in categoryList" :key="`${item.categoryList}-${index}`" @click.stop="toggle(item, item.categoryIdList[0], item.categoryId, sessionTarget) & $send('vschool_courseclass_courseclassother_buttonclick', {'sessionTarget': sessionTarget, 'courseclass': item.categoryName, 'categoryId': item.categoryId })" :class="{'active': (!item.children || !item.children.length) && (item.isOpen)}">
          <!-- <i class="nav-icon"></i> -->
          <div>
            <p>
              <a href="javascript:;">
                {{item.categoryName}}
              </a>
            </p>
            <i class="iconfont" :class="{'icon-rule-arrow-down': item.isOpen, 'icon-rule-arrow-up': !item.isOpen}" v-if="item.children && item.children.length"></i>
            <i class="arrow-icon" v-if="(!item.children || !item.children.length) && item.isOpen"></i>
          </div>
          <template v-if="item.children && item.children.length && (item.isOpen)">
            <tree v-model:categoryList="item.children" @toggle="toggle" :menuCategory="menuCategory"></tree>
          </template>
        </li>
      </ul>
    </div>
    <div class="righter-container">
      <section class="recommend-container">
        <div class="tab-container">
          <ul class="clearfix">
            <li v-for="(item, index) in tabs" :key="index" :class="{'active': item.value === this.activeName}" @click="toggleTab(item.value)" mars_sead="vschool_courseclass_courserank_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'courserank': item.label })">
              {{item.label}}
            </li>
          </ul>
        </div>
        <div class="list-container">
          <view-container :loading="loading" :empty="empty" :error="error" @retry="loadData">
            <ul>
              <li v-for="(item, index) in courseOverviewsList" :key="index">
                <dl>
                  <dt>
                    <router-link :to="{ name: 'CourseDetail', params: {target: sessionTarget, courseId: item.courseId}}" @click="$send('vschool_courseclass_coursecard_buttonclick', {'sessionTarget': sessionTarget, 'courseId': item.courseId})">
                      <imgWrap :src="item.coverUrl" width="304" height="194" :alt="item.title" :item="item" :pic="'coverUrl'"/>
                    </router-link>
                  </dt>
                  <dd>
                    <p class="list-title">
                      <router-link :to="{ name: 'CourseDetail', params: {target: sessionTarget, courseId: item.courseId}}">
                        {{item.title}}
                      </router-link>
                    </p>
                    <p class="list-tips">
                      <span v-if="item.duration">
                        时长
                        {{parseDuration(item.duration)}}
                      </span>
                      
                      <span v-if="item.hot">
                        <i class="eye-icon"></i>
                        {{item.hot}}
                      </span>
                      <span style="font-size:12px; color:#999;" v-if="item.avgRating > 0">
                        <!-- {{ item.learningCount > 0 ? item.learningCount + '人学习' : '' }} -->
                        {{ item.avgRating > 0 ? ' | ' + item.avgRating + '分' : '' }}</span>
                    </p>
                  </dd>
                </dl>
              </li>
            </ul>
          </view-container>
        </div>
      </section>
      <pagination v-model:pageModal="page" @query="loadData()"/>
    </div>
  </div>
</section>
</template>

<script>
import { mapActions, mapState} from 'vuex'
import pic from '../../assets/img/production-pic.png'
import tree from './tree.vue'
import pagination from '@/components/pagination.vue'
import util from '@/util/index.js'
import imgWrap from '@/components/imgWrap'
export default {
  name: '',
  data () {
    return {
      pic,
      menuCategory: 0,
      categoryList: [],
      categoryId: 0,
      selectedCategoryId: null,
      page: {
        pageNo: 1,
        pageSize: 9,
        total: 0
      },
      activeName: 0,
      tabs: [
        {
          label: '按时间',
          value: 0
        },
        {
          label: '按热度',
          value: 1
        }
      ],
      loading: false,
      empty: false,
      error: false
    }
  },
  setup () {
  },
  computed: {
    ...mapState(['courseOverviewsList', 'sessionTarget', 'queryUserPromise'])
  },
  mounted () {
    this.queryUserPromise.then(() => {
      const {
        menuCategory,
        categoryId
      } = this.$route.params
      this.menuCategory = Number(menuCategory)
      this.categoryId = Number(categoryId)
      this.reload()
    })
  },
  methods: {
    reload () {
      const {
        menuCategory,
        categoryId
      } = this.$data
      let _this = this
      this.queryCategoryTree(menuCategory === categoryId).then((resp) => {
        let result = resp.children || []
        ;(function setLayer(list, layer, parent) {
          list.forEach((item) => {
            item.categoryIdList = JSON.parse(JSON.stringify(parent))
            item.categoryIdList.push(item.categoryId)
            item.layer = layer
            if (categoryId === item.categoryId) {
              _this.selectedCategoryId = item.categoryIdList
              if (window.categoryId === item.categoryId) {
                item.isOpen = !item.isOpen
              } else {
                item.isOpen = true
              }
            }
            if (item.children && item.children.length) {
              setLayer(item.children, layer + 1, item.categoryIdList)
            }
          })
        })(result, 0, [])
        ;(function setOpenStatus(list) {
          list.forEach((item) => {
            if (_this.selectedCategoryId.includes(item.categoryId)) {
              if (window.categoryId === item.categoryId) {
                item.isOpen = !item.isOpen
              } else {
                item.isOpen = true
              }
            }
            if (item.children && item.children.length) {
              setOpenStatus(item.children)
            }
          })
        })(result, 0, [])
        this.categoryList = result.filter((item) => {
          if (item.categoryId === this.menuCategory) {
            return true
          }
        })[0].children || []
        this.categoryId = categoryId || result[0] && result[0].categoryId
        setTimeout(() => {
          this.loadData()
        }, 0)
      })
    },
    toggle (item, menuCategory, categoryId, target) {
      if (item.isOpen && (!item.children || !item.children.length)) {
        return
      }
      // console.log(11, menuCategory, categoryId, target)
      (function setOpenStatus(list) {
        list.forEach((item) => {
          if (item.categoryId === categoryId) {
            item.isOpen = !item.isOpen
          }
          if (item.children && item.children.length) {
            setOpenStatus(item.children)
          } else if (item.categoryId !== categoryId) {
            item.isOpen = false
          }
        })
      })(this.categoryList, 0, [])
      window.categoryId = categoryId
      // console.log(item)
      // item.isOpen = !item.isOpen
      this.$router.push({
        name: 'courseOverview',
        params: {
          menuCategory,
          categoryId,
          target
        }
      })
    },
    loadData () {
      const {
        menuCategory,
        categoryId
      } = this.$route.params
      this.menuCategory = Number(menuCategory)
      this.categoryId = Number(categoryId)
      this.categoryId && this.toggleTab()
    },
    toggleTab (activeName = this.activeName) {
      this.activeName = activeName
      const {
        pageNo,
        pageSize
      } = this.page
      this.loading = true
      this.error = false
      this.empty = false
      let queryCourseOverviewsPromise = this.queryCourseOverviews({
        categoryId: this.categoryId,
        pageNo,
        pageSize,
        sortType: this.activeName// sortType为0表示按时间排序，为1表示按热度排序
      })
      let queryCourseCountPromise = this.queryCourseCount(this.categoryId)
      Promise.all([queryCourseOverviewsPromise, queryCourseCountPromise]).then((resp) => {
        this.page.total = resp[1] || 0
        if (!this.page.total) {
          this.empty = true
        }
      }).catch(() => {
        this.error = true
        this.empty = false
      }).finally(() => {
        this.loading = false
      })
    },
    ...mapActions(['queryCategoryTree', 'queryCourseOverviews', 'queryCourseCount']),
    parseDuration: util.parseDuration
  },
  components: {
    tree,
    pagination,
    imgWrap
  }
}
</script>

<style lang="scss" scoped>
.course-container {
  margin-top: 25px;
  display: flex;
  .lefter-title {
    line-height: 28px;
  }
  .lefter-container {
    // float: left;
    flex: 1;
    width: 296px;
    max-width: 296px;
    background: #fff;
    border-radius: 8px;
    padding: 0 32px;
    margin-bottom: 25px;
    .lefter-title {
      font-size: 18px;
      font-weight: 600;
      margin-top: 27px;
      color: #333;
    }
    & > ul{
      margin-left: 0px;
    }
    ul {
      li {
        float: left;
        width: 100%;
        font-size: 16px;
        position: relative;
        cursor: pointer;
        min-height: 44px;
        line-height: 44px;
        border-radius: 5px;
        margin:0 0 0;
        > div {
          border-radius: 5px;
          margin: 8px 0;
          position: relative;
          padding-left: 8px;
        }
        .nav-icon {
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url(../../assets/img/nav-icon.png) no-repeat;
          margin-top: 5px;
        }
        .iconfont, /deep/ .iconfont {
          position: absolute;
          right: 0;
          top: 0px;
          z-index: 1;
        }
        a:hover {
          color: #FD3374;
          text-decoration: none;
        }
        &.active {
          > div {
            background: #f4f5f7;
            color: #333;
          }
        }
        .arrow-icon {
          position: absolute;
          right: 8px;
          top: 17px;
          width: 0;
          height: 0;
          font-size: 0;
          overflow: hidden;
          border-style: solid;
          border-color: transparent transparent transparent #656565;
          border-width: 5px;
        }
        &:last-child {
          margin-bottom: 4px;
        }
      }
    }
  }
  .righter-container {
    // float: left;
    flex: 1;
    width: 976px;
    min-width: 976px;
    padding-left: 25px;
    min-height: 200px;
    .recommend-container {
      .tab-container {
        text-align: right;
        margin-top: 0;
        ul {
          text-align: right;
          li {
            font-size: 14px;
            border: 1px solid #ccc;
            margin: 0;
            width: 68px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            margin-left: -1px;
            color: #666;
            cursor: pointer;
            &.active {
              border: 1px solid #FD3374;
              color: #FD3374;
              position: relative;
              z-index: 1;
              background: #fff;
            }
            &:first-child {
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
            }
            &:last-child {
              border-top-right-radius: 5px;
              border-bottom-right-radius: 5px;
            }
          }
        }
      }
      .list-container {
        margin-top: 20px;
      }
    }
  }
}
.recommend-container {
  .tab-container {
    margin-top: 40px;
    ul {
      text-align: center;
      li {
        display: inline-block;
        color: #666;
        font-size: 24px;
        line-height: 34px;
        margin: 0 35px;
      }
      .active {
        color: #333;
      }
    }
  }
  .list-container {
    margin-top: 45px;
    ul {
      display: flex;
      flex-wrap: wrap;
      margin-left: -16px;
      margin-right: -16px;
      li{
        flex: 0 0 25%;
        margin-bottom: 25px;
      }
    }
    dl {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      margin: 0 16px;
      height: 100%;
      dt {
        width: 304px;
        height: 194px;
      }
      dd {
        font-size: 16px;
        line-height: 22px;
        color: #333;
        font-weight: bold;
        padding-left: 12px;
        padding-top: 8px;
        .list-title {
          width: 274px;
          height: 44px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          word-break: normal;
          padding-top: 6px;
          padding-bottom: 3px;
        }
        p.list-tips {
          font-size: 12px;
          font-weight: normal;
          color: #666;
          text-align: right;
          font-family: Arial, Helvetica, sans-serif;
          padding-top: 5px;
          padding-bottom: 5px;
          padding-right: 16px;
          .eye-icon {
            background: url(../../assets/img/search_icon_show@2x.png) no-repeat;
            background-size: 14px;
            display: inline-block;
            width: 14px;
            height: 12px;
            margin-left: 16px;
          }
        }
      }
    }
  }
}
</style>
